import getMetaData from "./getMetaData";

export { getMetaData};

export const removeTags = (str: string) => {
  return str?.replace(/<[^>]*>?/gm, "") || "";
};

export function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    (navigator as any).msMaxTouchPoints > 0
  );
}
